import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Bottom extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }
    render() {
        return (
            <div className="bot">
                <div className="bot-wz">
                    <div className="bot-wz-1">Copyright © 2026</div>
                    <div className="bot-wz-1">上应大理学院光探测与感知课题组 版权所有</div>
                    <div className="bot-wz-1">豫ICP备2026001214号</div>
                    <Link to="/" className="bot-wz-1">网站地图</Link>
                </div>
            </div>
        );
    }
}

export default Bottom;
